import { useEffect, useState } from "react";

import { listMyJobApplications } from "../servics/field-work-service";
import { currentSession, INDIVIDUAL_ROLE } from "../utils/session";

/** Présentation des statuts d'une candidature (marketplace_job_application.status). */
export const JOB_APPLICATION_STATUS = {
    APPLIED: { label: "Candidature envoyée", color: "blue" },
    ACCEPTED: { label: "Candidature acceptée", color: "green" },
    REJECTED: { label: "Candidature refusée", color: "red" },
    WITHDRAWN: { label: "Candidature retirée", color: "default" }
};

/**
 * Candidatures du particulier connecté aux offres de travaux champêtres
 * (GET /me/job-applications). Rien n'est chargé pour un compte entreprise ou un
 * visiteur : seuls les particuliers (rôle INDIVIDUAL) postulent.
 */
const useMyJobApplications = () => {
    const session = currentSession();
    const isIndividual = session?.role === INDIVIDUAL_ROLE;
    const token = isIndividual ? session.token : null;

    const [state, setState] = useState({ loading: isIndividual, error: null, applications: [] });

    useEffect(() => {
        if (!token) {
            setState({ loading: false, error: null, applications: [] });
            return undefined;
        }
        let cancelled = false;
        setState((previous) => ({ ...previous, loading: true }));
        listMyJobApplications(token)
            .then((applications) => {
                if (!cancelled) setState({ loading: false, error: null, applications });
            })
            .catch((error) => {
                console.warn("Candidatures indisponibles", error);
                if (!cancelled) setState({ loading: false, error, applications: [] });
            });
        return () => { cancelled = true; };
    }, [token]);

    return {
        ...state,
        isIndividual,
        accepted: state.applications.filter((application) => application.status === "ACCEPTED")
    };
};

export default useMyJobApplications;
